export const MESSAGE_TYPES = {
    ACCORDION: "accordion",
    CAROUSEL: "carousel",
    FILE_DOWNLOAD: "fileDownload",
    VIDEO: "video",
    IMAGE: "image",
    TEXT: "text",
    QUICK_REPLY: "quickReply",
    SESSION_DIVIDER: "sessionDivider",
    RATING: "rating",
};
//# sourceMappingURL=message.constants.js.map